<template>
    <div class="widget-sound-settings">
        <RedesignFormItem
            :label="t('widget.config.maximumWarningCallersValue')"
        >
            <VcInputNumber
                v-model="soundModel.maximumWarningCallersValue"
                :max-value="100"
                :min-value="0"
                :step="1"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('widget.config.maximumLimitCallersValue')"
        >
            <VcInputNumber
                v-model="soundModel.maximumLimitCallersValue"
                :max-value="100"
                :min-value="0"
                :step="1"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('widget.config.maximumWarningMaxRingTimeValue')"
        >
            <VcTimeInput
                v-model="soundModel.maximumWarningMaxRingTimeValue"
                :min-value="0"
                :step="1"
                class="input-number"
                max-width="200px"
                color="primary"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('widget.config.maximumLimitMaxRingTimeValue')"
        >
            <VcTimeInput
                v-model="soundModel.maximumLimitMaxRingTimeValue"
                :min-value="0"
                :step="1"
                class="input-number"
                max-width="200px"
                color="primary"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumWarningCallersColor')"
        >
            <RedesignWidgetColor
                v-model:value="soundModel.maximumWarningCallersColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumLimitCallersColor')"
        >
            <RedesignWidgetColor
                v-model:value="soundModel.maximumLimitCallersColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumWarningMaxRingTimeColor')"
        >
            <RedesignWidgetColor
                v-model:value="soundModel.maximumWarningMaxRingTimeColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumLimitMaxRingTimeColor')"
        >
            <RedesignWidgetColor
                v-model:value="soundModel.maximumLimitMaxRingTimeColor"
                :predefine="predefinedColors"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumWarningCallersSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumWarningCallersSound"
                :placeholder="t('settings.maximumWarningCallersSound')"
                :options="warningSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumLimitCallersSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumLimitCallersSound"
                :placeholder="t('settings.maximumLimitCallersSound')"
                :options="errorSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumWarningMaxRingTimeSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumWarningMaxRingTimeSound"
                :placeholder="t('settings.maximumWarningMaxRingTimeSound')"
                :options="warningSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.maximumLimitMaxRingTimeSound')"
        >
            <SoundSelect
                v-model="soundModel.maximumLimitMaxRingTimeSound"
                :placeholder="t('settings.maximumLimitMaxRingTimeSound')"
                :options="errorSoundList"
            />
        </RedesignFormItem>
        <RedesignFormItem
            :label="t('settings.backQueueSLASound')"
        >
            <SoundSelect
                v-model="soundModel.backQueueSLASound"
                :placeholder="t('settings.backQueueSLASound')"
                :options="allSoundList"
            />
        </RedesignFormItem>
    </div>
</template>

<script setup lang="ts">
import { WidgetLayout } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import RedesignWidgetColor from '@/components/RedesignComponents/Widgets/Common/RedesignWidgetColor.vue'
import { predefinedColors } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import SoundSelect from '@/components/Common/SoundSelect.vue'
import { allSoundList, errorSoundList, warningSoundList } from '@/composables/globalData/useEntitiesData'
import { VcInputNumber } from '@voicenter-team/voicenter-ui-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    modelValue: WidgetLayout
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', v: WidgetLayout): void
}>()

const soundModel = useVModel(props, 'modelValue', emit)
</script>
